import React from "react";
import clsx from "clsx";

interface ButtonProps {
  title: string;
  onClick?: () => void;
  type?: "button" | "submit";
  disabled?: boolean;
  loading?: boolean;
  variant?: "filled" | "outline" | "secondary";
  className?: string;
  icon?: React.ReactNode;
}

const OnboardingButton: React.FC<ButtonProps> = ({
  title,
  onClick,
  type = "button",
  disabled = false,
  loading = false,
  variant = "filled",
  className = "",
  icon
}) => {
  const baseClasses = "relative flex items-center justify-center w-full py-4 px-6 font-semibold text-base rounded-xl transition-all duration-200 box-border active:scale-[0.98] font-['Proxima_Nova'] rounded-lg";
  const filledClasses = "!bg-[#1A1F3C] !text-white border-[2px] border-transparent hover:!bg-[#2A315A]";
  const outlineClasses = "!bg-white !text-[#1A1F3C] border-[2px] !border-[#1A1F3C] hover:!bg-[#1A1F3C] hover:!text-white";
  const secondaryClasses = "!bg-[#EAEBF0] !text-[#111218] border-[2px] border-transparent hover:!bg-[#D8D9E0]";

  const isDisabled = disabled || loading;

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={isDisabled}
      className={clsx(
        baseClasses,
        variant === "filled"
          ? filledClasses
          : variant === "outline"
          ? outlineClasses
          : secondaryClasses,
        isDisabled ? "opacity-50 cursor-not-allowed" : "cursor-pointer",
        className
      )}
    >
      <span className={clsx("text-center", loading && "opacity-0")}>
        {title}
        {icon && (
          <span className="inline-flex align-middle ml-2">
            {icon}
          </span>
        )}
      </span>
      {loading && (
        <span className="absolute h-5 w-5 animate-spin rounded-full border-2 border-current border-t-transparent" />
      )}
    </button>
  );
};

export default OnboardingButton;